export const SATELLITE_PRO_GRANT_SECONDS = 60 * 60;
export const SATELLITE_PRO_GRANT_REFRESH_SECONDS = 50 * 60;

export function isSatelliteBasemap(id: string | null | undefined): id is 'satellite' | 'hybrid' {
  return id === 'satellite' || id === 'hybrid';
}
